import ProfileSettings from './ProfileSettingsContainer';

export default ProfileSettings;
